module.exports = __webpack_public_path__ + "img/arrow3.fd8b9560.svg";